module.exports = __webpack_public_path__ + "static/media/bg3.497f63ec.png";